import React from "react";

const ReplicationStudies = () => {
  return (
    <React.Fragment>
      <h1>Replication Studies and Negative/Null Results</h1>

      <p>
        Publishing negative/null results helps other researchers refine their hypothesis and
        optimize their approach. Therefore, we encourage the submission of all such results,
        provided they are meaningful. For instance, a negative/null result that is the direct
        outcome of poor methodology or inadequate statistical rigor cannot be published in CJBE.
      </p>
      <p>
        By definition, all published research is expected to be reproducible. Therefore, as a matter
        of policy, CJBE only considers replication studies that address certain controversies from
        the field.
      </p>
    </React.Fragment>
  );
};

export default ReplicationStudies;
